/**
 * Most common value in a list of betting points. Ties break to the LOWER point so
 * mirrored run lines (±1.5) and totals stay stable across renders. Shared by the
 * slate consensus selector and the slate best-line resolver.
 */
export function modeOfPoints(values: ReadonlyArray<number>): number | undefined {
  if (values.length === 0) return undefined;
  const counts = new Map<number, number>();
  for (const v of values) counts.set(v, (counts.get(v) ?? 0) + 1);
  let best: number | undefined;
  let bestCount = 0;
  for (const [v, c] of counts) {
    if (c > bestCount || (c === bestCount && best !== undefined && v < best)) {
      best = v;
      bestCount = c;
    }
  }
  return best;
}
